import { Stage } from "@/types/billing";
import { PeriodSelector } from "./PeriodSelector";
import { StageRail } from "./StageRail";
import { LocationPicker } from "@/components/ui/LocationPicker";

interface Props {
  periodId: string;
  onPeriodChange: (id: string) => void;
  stage: Stage;
  location: string | null;
  onLocationChange: (loc: string | null) => void;
}

export function InvoicingHeader({ periodId, onPeriodChange, stage, location, onLocationChange }: Props) {
  return (
    <div className="flex flex-col gap-2 mb-4 pb-3 border-b border-border">
      {/* Row 1: period + location picker */}
      <div className="flex flex-wrap items-center gap-3">
        <div className="w-36">
          <PeriodSelector value={periodId} onChange={onPeriodChange} />
        </div>
        <LocationPicker value={location} onChange={onLocationChange} />
      </div>

      {/* Row 2: stage rail on its own line — never wraps onto action buttons */}
      <StageRail stage={stage} />
    </div>
  );
}
